export default __webpack_public_path__ + "static/media/home-statistics-bg.88e0517e.png";